import { CustomerLicense } from './customer-license.model';

export class CustomerDetails {
    Id: string;
    nameId: string;
    name: string;
    city: string;
    phoneNumber: string;
    state: string;
    addressline1: string;
    addressline2: string;
    company: {
        name: string;
    }
    licenses: CustomerLicense[];
    accountSinceDate: string;
    accumulatePatronage: string;
    activeStatus: string;
    addressLine1Partial: string;
    addressLine2Partial: string;
    bankDefaultACP: string;
    bankDefaultACR: string;
    bankDefaultGRNCheck: string;
    bankDefaultGRNReceipt: string;
    chargeTax1: string;
    chargeTax2: string;
    chargeTax3: string;
    chargeTax4: string;
    cityPartial: string;
    commodityDiscountTable: string;
    country: string;
    CountyCode: string;
    currencyCode: string;
    deferredPayDate: string;
    financeChargeTable: string;
    invoiceTerms: string;
    misc1Code: string;
    misc2Code: string;
    misc3Code: string;
    misc3CodeDV: string;
    misc4Code: string;
    misc5Code: string;
    misc6Code: string;
    nameIdType: string;
    nameIdTypeDV: string;
    namePartial1of3: string;
    namePartial2of3: string;
    otherReference: string;
    parentNameID: string;
    priceLevel: string;
    priceSchedule: string;
    purchaseCreditLimit: string;
    remark1: string;
    remark2: string;
    requireTheirDocumentNumber: string;
    salesCreditLimit: string;
    socialSecurityFederalId: string;
    stateCode: string;
    tran1Code: string;
    tran2Code: string;
    tran3Code: string;
    tran4Code: string;
    tran5Code: string;
    voucherTerms: string;
    zipCode: string;
    cityStateZip: string;
    createdBy: string;
    createdDate: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    sqlID: string;
    tenantID: string;
    alternate: string;
    billToRemitTo: string;
    collectionPoint: string;
    contactDetails: any;
    contactRemarks: string;
    farms: string;
    federalRegisteredName: string;
    primaryContact: any;
    mailToEmails:string;
    deliveryPoints:any[];
    constructor() {
        this.nameId = '';
        this.name = '';
        this.city = '';
        this.state = '';
        this.phoneNumber = '';
        this.addressline1 = '';
        this.addressline2 = '';
        this.licenses = [];
        this.primaryContact = '';
        this.mailToEmails = '';
        this.deliveryPoints = [];
    }

}